import {isbuild} from './isbuild'
export const BASE_URL = isbuild === 'dev' ? '/adyounger' : 'https://sspi.adyounger.com'